import ButtonGroup from './button-group.component'

export default ButtonGroup
